import { Avatar } from "@atoms/index"

import { objectMap } from "@constants/objectMap"

import { ObjectAvatarProps } from "./ObjectAvatar.types"

export default function ObjectAvatar(props: ObjectAvatarProps) {
    const { objectType, ...rest } = props

    return <Avatar variant="object" icon={objectMap[objectType].iconActive} {...rest} />
}
